import type { Amperes } from '@/features/execute-calculation-set/overmind/calculation/domain/ElectricCurrent';

import type { AttentionStatusType } from '../../../../AttentionStatus';
import type { ForMessaging } from '../../../../AttentionStatusRepository';
import type { EvaluatedResult } from '../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../RulesProvider';
import type { ForAcLineSegmentEvaluation } from '../../../gridElements/acLineSegment/forAcLineSegmentEvaluation';
import { AvailableCapacityEvaluation } from './propertiesEvaluation/AvailableCapacityEvaluation';
import { CurrentEvaluation } from './propertiesEvaluation/CurrentEvaluation';
import { LoadingPercentEvaluation } from './propertiesEvaluation/loadingPercent';

export class AcLineSegmentEvaluationEngine
  implements ForAcLineSegmentEvaluation
{
  constructor(private readonly rulesProvider: ForRuleProviding) {}

  evaluateCurrent(
    current: number,
    messenger: ForMessaging<AttentionStatusType>
  ) {
    const evaluation = new CurrentEvaluation(this.rulesProvider).evaluate(
      current
    );
    messenger.send(evaluation.status, this.evaluateCurrent.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateAvailableCapacity(
    capacity: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Amperes> {
    const evaluation = new AvailableCapacityEvaluation(
      this.rulesProvider
    ).evaluate(capacity);
    messenger.send(evaluation.status, this.evaluateAvailableCapacity.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateLoadingPercent(
    voltage: number,
    messenger: ForMessaging<AttentionStatusType>
  ) {
    const evaluation = new LoadingPercentEvaluation(
      this.rulesProvider
    ).evaluate(voltage);
    messenger.send(evaluation.status, this.evaluateLoadingPercent.name);
    return evaluation.toEvaluatedResult();
  }
}

export type LoadingPercentEvaluatedEvent = { status: AttentionStatusType };
